export const PVAGZuschuss = [
  {
    'PAISY Wert': '',
    Bezeichnung: 'entfällt',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'BBG',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'Entgelt',
  },
  {
    'PAISY Wert': 9,
    Bezeichnung: 'Kein AG Zuschuss',
  },
];
